import { Icon, IconBase, IconProps, IconWeight } from '@phosphor-icons/react'
import { forwardRef, ReactElement } from 'react'

const weights = new Map<IconWeight, ReactElement>([
  [
    'regular',
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M232.971 63.0294C242.343 72.402 242.343 87.598 232.971 96.9706L120.971 208.971C111.598 218.343 96.402 218.343 87.0294 208.971L31.0294 152.971C21.6569 143.598 21.6569 128.402 31.0294 119.029C40.402 109.657 55.598 109.657 64.9706 119.029L104 158.059L199.029 63.0294C208.402 53.6569 223.598 53.6569 232.971 63.0294Z"
        fill="currentColor"
      />
    </>,
  ],
])

const CheckIcon = forwardRef<
  SVGSVGElement,
  IconProps & {
    weight?: 'regular'
  }
>((props, ref) => <IconBase ref={ref} {...props} weights={weights} />)

export default CheckIcon as Icon
